export default {
    // Status
    open: 'Offen',
    closed: 'Geschlossen',
    groomedStatusCurrently: 'Körperpflege',
    groomedStatusPassed: 'Gepflegt ({{hoursPassed}} uhr)',
    groomedStatusYesterday: 'Gestern gepflegt',
    groomedStatusWeekday: 'Gepflegt {{weekday}}',
    // Zone
    low: 'Niedrige Zone',
    high: 'Hohe Zone',
    // Difficulty
    veryEasy: 'Sehr leicht',
    veryEasyPlural: 'Sehr leicht',
    easy: 'Einfach',
    easyPlural: 'Einfach',
    medium: 'Mittel',
    mediumPlural: 'Mittel',
    hard: 'Hart',
    hardPlural: 'Hart',
    // Abbreviated weekdays
    abbreviatedMonday: 'mo',
    abbreviatedTuesday: 'di',
    abbreviatedWednesday: 'mi',
    abbreviatedThursday: 'do',
    abbreviatedFriday: 'fr',
    abbreviatedSaturday: 'sa',
    abbreviatedSunday: 'so',
    // Measurements
    elevationAboveSeaLevel: 'Höhe ü. NN',
    // Misc
    switchDirection: 'Richtung wechseln',
    destinationNamePlaceholder: 'Zielname hier',
    mapTypeMap: 'Karte',
    mapTypeSatelite: 'Satellit',
    mapTypeThreeD: '3D',
    mapTypeThreeDSatelite: '3D Satellit',
    mapChooserTitle: 'Karte wahlen',
    mapChooserStandard: 'Standard',
    mapChooserThreeDStandard: '3D Std.',
    mapChooserThreeDSatellite: '3D Sat.',
    mapChooserSettingsTitle: 'Einstellungen',
    mapChooserDirection: 'Richtung',
    mapChooserOpen: 'Karte',
    mapChooserClose: 'Schliessen',
    mapFilterTitle: 'Filter',
    mapFilterPathTypes: 'Wegtypen',
    mapFilterPoiTypes: 'POI-Typen',
    mapFilterOpen: 'Filter',
    mapFilterClose: 'Schliessen',
    mapFilterReset: 'Zurucksetzen',
    compositeChildrenDropdownLabel: 'Teilstrecken',
    compositeChildLabel: 'Teilstrecke',
    compositeChildCount_one: '{{count}} Teilstrecke',
    compositeChildCount_other: '{{count}} Teilstrecken',
    expandCompositeTrail: 'Teilstrecken anzeigen',
    collapseCompositeTrail: 'Teilstrecken ausblenden',
    compositeParentLink: 'Zur zusammengesetzten Strecke: {{name}}',
    selectTrail: 'Weg auswahlen',
};